import { paths } from '@api/api';
import useAxios from '@hooks/useFetch';

export interface SuggestedSearch {
    text: string;
    id: number;
}

export interface CommonDataResponse {
    suggestedSearches: SuggestedSearch[];
}

export interface CommonDataResult {
    data: SuggestedSearch[];
    isLoading: boolean;
}

const COMMON_DATA_ENDPOINT: keyof paths = '/Common/Get';

export function useCommonData(): CommonDataResult {
    const { 
        data, 
        isLoading, 
    } = useAxios<CommonDataResponse>({
        method: 'get',
        url: COMMON_DATA_ENDPOINT,
    });

    return {
        data: data?.suggestedSearches || [],
        isLoading,
    };
}